import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'duration'})
export class DurationPipe implements PipeTransform {

    transform(value: number): string {
        return (value > 0) ? ((value < 60) ? value+" sec" : Math.floor(value / 60)+" min") : "-";
    }
}